import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { USERS_MY } from 'api/query-keys.ts';
import type { UserRes } from 'api/swagger';

export const useGetMy = (enabled: boolean = true) => {
  return useQuery<UserRes>({
    queryKey: [USERS_MY],
    queryFn: async () => {
      const { data } = await http.get<UserRes>('/v1/users/my');
      return data;
    },
    enabled,
    retry: 2,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};
